import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import VideoModal from "./videoModal";
import * as styles from './twoColTile.module.css';
import { gsap, TweenMax, Expo } from "gsap";

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

let imageClass = "inline-block align-middle";

const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function TwoColTile(props) {
    
    const sectionRef = useRef();
    const actionsRef = useRef();
    const titleRef = useRef();
    const contentRef = useRef();
    const ctaRef = useRef();
    const bgRef = useRef();

    const featuredimg = maybeImage(props.featuredimage);

    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [videoSrc, setVideoSrc] = useState(props.videoLink);

    let openVideoModal = () => {
        setVideoSrc(props.videoLink);
        setVideoModalOpen(true);
    }

    let closeVideoModal = () => {
        setVideoModalOpen(false);
        setVideoSrc('');

        TweenMax.to(
            titleRef.current, 
            0.45, 
            { 
                opacity: 1, 
                x: 0, 
                delay : 0.25
            } 
        );

        TweenMax.to(
            contentRef.current, 
            0.45, 
            { 
                opacity: 1, 
                x: 0, 
                delay : 0.45
            } 
        );

        TweenMax.to(
            ctaRef.current, 
            0.45, 
            { 
                opacity: 1, 
                x: 0, 
                delay : 0.65
            } 
        );

        TweenMax.to(
            actionsRef.current, 
            0.45, 
            { 
                opacity: 1, 
                y: 0, 
                delay : 0.65,
                onComplete : () => {
                    $(sectionRef.current).addClass('anim-complete');
                }
            } 
        );
    }

    let sectionClass = styles.sectionTwoColTile;
    if(props.minimalMargin){
        sectionClass += ' '+styles.minimalMargin;
    }

    useEffect(() => {

        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([titleRef.current, contentRef.current, ctaRef.current], {
        //     opacity: 0,
        //     x: 80
        // });
        // TweenMax.set(actionsRef.current, {
        //     opacity: 0,
        //     y: 80
        // });

        if(videoModalOpen){

        }

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                    // TweenMax.to(
                    //     titleRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.25
                    //     } 
                    // );

                    // TweenMax.to(
                    //     contentRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.45
                    //     } 
                    // );

                    // TweenMax.to(
                    //     ctaRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.65
                    //     } 
                    // );

                    // TweenMax.to(
                    //     actionsRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.65,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );
                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        }

    });

    let backgroundImage = (props.featuredimage) ? props.featuredimage.image.asset.url : '';

    return (
        <>
        <div className={sectionClass} ref={sectionRef}>
            <div className={styles.sectionContainer}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <div className={styles.contentText}>
                            <h2 ref={titleRef}>{props.heading}</h2>
                            <div ref={contentRef} className={styles.richtext}>
                                <PortableText blocks={props.content} />
                            </div>
                        </div>
                        <div className={styles.contentCta} ref={ctaRef}>
                            {
                                (props.ctalink) ? 
                                <a className={styles.cta} href={props.ctalink} target="_blank">
                                    {props.ctalabel}
                                </a> 
                                : ``
                            }
                        </div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.imageWrapper} ref={bgRef}>
                            <div className={styles.bgWrap}  style={{ backgroundImage : `url("${backgroundImage}")`}}></div>
                        </div>
                        {
                            (props.videoLink) ?
                            <div className={styles.playButton}>
                                <a href="javascript:void(0);" onClick={openVideoModal}>
                                    <img className={imageClass} src={require('../images/play-button.png').default} alt="Play button" />
                                </a>
                            </div>
                            : ``
                        }
                        <div className={styles.ctaWrap} ref={actionsRef}>
                            {
                                (props.searchpropertyink) ? 
                                <a className={styles.primaryCTA} href={props.searchpropertyink} target="_blank">
                                    <span><img className={imageClass} src={require('../images/search-icon.png').default} alt="icon" /></span>
                                    Search Property
                                </a> 
                                : ``
                            }
                            {
                                (props.sellyourhome) ? 
                                <a className={styles.secondaryCTA}  href={props.sellyourhome} target="_blank">
                                    <span><img className={imageClass} src={require('../images/home-icon.png').default} alt="icon" /></span>
                                    Sell your home
                                </a> 
                                : ``
                            }
                            {
                                (props.tagproperties) ? 
                                <a className={styles.tertiaryCTA}  href={props.tagproperties} target="_blank">
                                    <span><img className={imageClass} src={require('../images/tag-icon.png').default} alt="icon" /></span>
                                    Tag Properties
                                </a> 
                                : ``
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <VideoModal videoSrc={videoSrc} isOpen={videoModalOpen} closeVideoModal={closeVideoModal} />
        </>
    );
}

export default TwoColTile;